<template>
    <div>
        <!-- <div id="footer-bar" class="footer-bar footer-bar-detached"> -->
        <div id="footer-bar" class="footer-bar">
            <router-link :to="{ name: 'home' }">
                <i class="bi bi-house font-17"></i>
                <span>Home</span>
            </router-link>
            <router-link :to="{ name: 'news' }">
                <em 
                    v-if="postReadAllLocal < total_post" 
                    class="badge bage-number bg-yellow-dark font-12" 
                    style="height: 20px; min-width:20px; top:4px; line-height: 20px;"
                >{{ total_post - postReadAllLocal }}</em>
                <i class="bi bi-newspaper font-17"></i>
                <span>Berita</span>
            </router-link>
            <router-link :to="{ name: 'announcement' }">
                <em 
                    v-if="announcementsReadLocal.length < announcements_total" 
                    class="badge bage-number bg-yellow-dark font-12" 
                    style="height: 20px; min-width:20px; top:4px; line-height: 20px;"
                >{{ announcements_total - announcementsReadLocal.length }}</em>
                <i class="bi bi-megaphone-fill font-17"></i>
                <span>Pengumuman</span>
            </router-link>
            <router-link :to="{ name: 'event' }">
                <em 
                    v-if="eventsReadLocal.length < events_total" 
                    class="badge bage-number bg-yellow-dark font-12" 
                    style="height: 20px; min-width:20px; top:4px; line-height: 20px;"
                >{{ events_total - eventsReadLocal.length }}</em>
                <i class="bi bi-calendar4-week font-17"></i>
                <span>Event</span>
            </router-link>
        </div>
    </div>
</template>

<script>
import { 
	// mapMutations, 
	mapActions, mapState 
} from 'vuex'

export default {
    name: 'Footer',
    async created() {
		await this.getHomepagePost()
		await this.getAnnouncementsCount()
		await this.getEventsCount()
    },
    methods: {
        ...mapActions('postWp', ['getHomepagePost']),
        ...mapActions('announcementWp', ['getAnnouncementsCount']),
        ...mapActions('eventWp', ['getEventsCount']),
    },
    computed: {
        ...mapState({
            loading: state => state.loading
        }),
        ...mapState('postWp', {
            total_post: state => state.total_post,
        }),
        ...mapState('announcementWp', {
            announcements_total: state => state.announcements_total,
        }),
        ...mapState('eventWp', {
            events_total: state => state.events_total,
        }),
		...mapState('notificationLocal', {
            postsReadLocal: state => state.postsReadLocal,
            postReadAllLocal: state => state.postReadAllLocal,
			announcementsReadLocal: state => state.announcementsReadLocal,
			eventsReadLocal: state => state.eventsReadLocal,
        }),
    }
}
</script>